module.exports = __webpack_public_path__ + "img/user.b7ee6ff5.svg";